import { Show, createEffect, createSignal } from "solid-js";
import { Form, Button, Spinner } from "solid-bootstrap";
import { fetchResource } from "../../../util/fetch";
import { Service } from "../../../service/device/setup";

export function ThemeForm(props) {
    console.log(`ThemeForm for UUID: ${props.theme.uuid}`);
    const [myTheme, refetch] = fetchResource(() => Service.getTheme(props.theme.uuid));
    refetch();
    const [isSubmitting, setIsSubmitting] = createSignal(false);
    const [isError, setIsError] = createSignal(false);
    createEffect(() => {
        if (!myTheme.loading) {
            props.setTheme(myTheme());
        }
    });
    const onSubmit = (ev) => {
        ev.preventDefault();
        if (props.validate !== undefined && !props.validate()) {
            return;
        }
        setIsSubmitting(true);
        setIsError(false);
        Service.getTheme(props.theme.uuid).then(systemTheme => {
            props.readFormFields(systemTheme);
            Service.updateTheme(systemTheme).then(() => {
                refetch();
            }).catch(() => {
                setIsError(true);
            }).finally(() => {
                setIsSubmitting(false);
            });
        });
    };
    return <>
        <h1 class="mb-3">{props.title}</h1>
        <Show when={!myTheme.loading}>
            <Form onSubmit={onSubmit} class="d-flex flex-column gap-3">
                {props.children}
                <div class="d-flex flex-row gap-3">
                    <Button type="submit">{props.submitText}</Button>
                    <Show when={isSubmitting()}><Spinner animation="border" /></Show>
                    <Show when={!isSubmitting()}>
                        <i>Saved</i>
                    </Show>
                    <Show when={isError()}>
                        <i>Error</i>
                    </Show>
                </div>
            </Form>
        </Show>
        <Show when={myTheme.loading}>
            <Spinner animation="border"/>
        </Show>
    </>
}